exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-header-author .author-thumb{\r\n    overflow: unset !important;\r\n}\r\n\r\n.advisor {\r\n    border: 3px solid #ffa26b  !important;\r\n}\r\n\r\n.advisor::after{\r\n    content: url(\"/assets/images/advisor.png\");\r\n    position: absolute;\r\n    top: 80px;\r\n    left: 85px;\r\n    -webkit-transform: scale(0.7);\r\n    transform: scale(0.7);\r\n}\r\n\r\n.senior-advisor {\r\n    border: 3px solid #4e2875  !important;\r\n}\r\n\r\n.senior-advisor::after{\r\n    content: url(\"/assets/images/senior-advisor.png\");\r\n    position: absolute;\r\n    top: 80px;\r\n    left: 85px;\r\n    -webkit-transform: scale(0.7);\r\n    transform: scale(0.7);\r\n}\r\n\r\n.bigadvisor {\r\n    border: 3px solid #ff1913 !important;\r\n}\r\n\r\n.bigadvisor::after{\r\n    content: url(\"/assets/images/bigadvisor.png\");\r\n    position: absolute;\r\n    top: 80px;\r\n    left: 85px;\r\n    -webkit-transform: scale(0.7);\r\n    transform: scale(0.7);\r\n}\r\n\r\n.top-header-author .author-thumb img{\r\n    border-radius: 100% !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/profile-wrapper/profile-wrapper.component.css
// module id = ../../../../../src/app/profile-update/profile-wrapper/profile-wrapper.component.css
// module chunks = main